import { useObjectRef } from '@react-aria/utils'
import { forwardRef, useState } from 'react'
import Styles from '../ElementsTab.module.scss'
import { DraggableShape } from '../../DraggableShape/DraggableShape'
import { ElementProps } from '../Types'

export const Element = forwardRef<HTMLDivElement, ElementProps>(({ children, onPress, shape, ...rest }, fRef) => {
  const ref = useObjectRef(fRef)
  const [draggableEl, setDraggableEl] = useState<HTMLDivElement | null>(null)

  let newHeight = shape.props.h
  const draggableBoundingBox = draggableEl?.getBoundingClientRect()
  if (draggableBoundingBox && draggableBoundingBox.width > 0 && draggableBoundingBox.height > 0) {
    const originalWidth = draggableBoundingBox.width
    const originalHeight = draggableBoundingBox.height
    newHeight = (originalHeight / originalWidth) * shape.props.w
  }

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault()
    e.stopPropagation()
    onPress(e, { w: shape.props.w, h: newHeight })
  }

  return (
    <DraggableShape
      payload={{
        ...shape,
        props: {
          ...shape.props,
          h: newHeight,
        },
      }}
      dragImage={() => {
        if (!draggableBoundingBox) return null
        return children
      }}
      draggableEl={draggableEl}
    >
      <div {...rest} onClick={handleClick} className={Styles.element} ref={ref}>
        <div ref={setDraggableEl}>{children}</div>
      </div>
    </DraggableShape>
  )
})
